export default __webpack_public_path__ + "static/media/munnar2.0d638fdf.jpg";